// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-grid_ldsGrid__4SwdQ {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.styles-grid_ldsGrid__4SwdQ div {
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--primary-color);
    animation: styles-grid_ldsGrid__4SwdQ 1.2s linear infinite;
}
.styles-grid_ldsGrid__4SwdQ div:nth-child(1) {
    top: 8px;
    left: 8px;
    animation-delay: 0s;
}
.styles-grid_ldsGrid__4SwdQ div:nth-child(2) {
    top: 8px;
    left: 32px;
    animation-delay: -0.4s;
}
.styles-grid_ldsGrid__4SwdQ div:nth-child(3) {
    top: 8px;
    left: 56px;
    animation-delay: -0.8s;
}
.styles-grid_ldsGrid__4SwdQ div:nth-child(4) {
    top: 32px;
    left: 8px;
    animation-delay: -0.4s;
}
.styles-grid_ldsGrid__4SwdQ div:nth-child(5) {
    top: 32px;
    left: 32px;
    animation-delay: -0.8s;
}
.styles-grid_ldsGrid__4SwdQ div:nth-child(6) {
    top: 32px;
    left: 56px;
    animation-delay: -1.2s;
}
.styles-grid_ldsGrid__4SwdQ div:nth-child(7) {
    top: 56px;
    left: 8px;
    animation-delay: -0.8s;
}
.styles-grid_ldsGrid__4SwdQ div:nth-child(8) {
    top: 56px;
    left: 32px;
    animation-delay: -1.2s;
}
.styles-grid_ldsGrid__4SwdQ div:nth-child(9) {
    top: 56px;
    left: 56px;
    animation-delay: -1.6s;
}
@keyframes styles-grid_ldsGrid__4SwdQ {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loader/components/LoaderGrid/styles-grid.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,0DAAuC;AAC3C;AACA;IACI,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,QAAQ;IACR,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,QAAQ;IACR,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI;;QAEI,UAAU;IACd;IACA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".ldsGrid {\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n}\n.ldsGrid div {\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: var(--primary-color);\n    animation: ldsGrid 1.2s linear infinite;\n}\n.ldsGrid div:nth-child(1) {\n    top: 8px;\n    left: 8px;\n    animation-delay: 0s;\n}\n.ldsGrid div:nth-child(2) {\n    top: 8px;\n    left: 32px;\n    animation-delay: -0.4s;\n}\n.ldsGrid div:nth-child(3) {\n    top: 8px;\n    left: 56px;\n    animation-delay: -0.8s;\n}\n.ldsGrid div:nth-child(4) {\n    top: 32px;\n    left: 8px;\n    animation-delay: -0.4s;\n}\n.ldsGrid div:nth-child(5) {\n    top: 32px;\n    left: 32px;\n    animation-delay: -0.8s;\n}\n.ldsGrid div:nth-child(6) {\n    top: 32px;\n    left: 56px;\n    animation-delay: -1.2s;\n}\n.ldsGrid div:nth-child(7) {\n    top: 56px;\n    left: 8px;\n    animation-delay: -0.8s;\n}\n.ldsGrid div:nth-child(8) {\n    top: 56px;\n    left: 32px;\n    animation-delay: -1.2s;\n}\n.ldsGrid div:nth-child(9) {\n    top: 56px;\n    left: 56px;\n    animation-delay: -1.6s;\n}\n@keyframes ldsGrid {\n    0%,\n    100% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.5;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ldsGrid": `styles-grid_ldsGrid__4SwdQ`
};
export default ___CSS_LOADER_EXPORT___;
